import { createFileRoute } from "@tanstack/react-router"
import { getGetResourceObjectQueryKey, ResourceObjectDto } from "@/orval/gen"
import { ResourceObjectDetailsPage } from "../-components/ResourceObjectDetailsPage/index"

export const Route = createFileRoute("/app/resources/resource-objects/$id")({
  component: ResourceObjectDetailsPage,
  beforeLoad: ({ context: { queryClient }, params: { id } }) => ({
    getTitle: () =>
      queryClient?.getQueryData<ResourceObjectDto>(
        getGetResourceObjectQueryKey({ resourceObjectId: parseInt(id) })
      )?.name,
  }),
})
